
<div class="tag-input">
  <div :class="['input', { active }]" @click="active = true">
    <label>{{ label }}</label>

    <div class="values">
      <div
        class="chip"
        v-for="(item, i) in value"
        :key="i"
        @click.stop="removeItem(i)"
      >
        <span>{{ item }}</span>

        <icon name="cancel" />
      </div>

      <input
        ref="input"
        v-model="inputString"
        @focus="onInputFocus"
        @blur="onInputBlur"
        @keydown="handleKeyDown"
      />
    </div>
  </div>
</div>
